import { render, staticRenderFns } from "./ManageDownloadCenter.vue?vue&type=template&id=07197b5c&scoped=true&"
import script from "./ManageDownloadCenter.vue?vue&type=script&lang=js&"
export * from "./ManageDownloadCenter.vue?vue&type=script&lang=js&"
import style0 from "./ManageDownloadCenter.vue?vue&type=style&index=0&id=07197b5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07197b5c",
  null
  
)

export default component.exports